import { isVkPlay } from '@vkplay/shared';
import Loader from '@components/Loader';
import { PAGE_NAME } from '../../utils/services';

export default {
  name: 'MainPage',
  components: {
    Loader,
  },
  page() {
    return {
      title: this.$t(isVkPlay ? 'docTitle.docsVkPlay' : 'docTitle.docs', { page: PAGE_NAME }),
    };
  },
  computed: {
    isVisibleTechDocs() {
      return this.$i18n.locale !== 'ru_RU' && this.$i18n.locale !== 'en_US';
    },
    sections() {
      return this.$store.getters['docs/getterSections'];
    },
    sectionsData() {
      return this.sections.data;
    },
    isLoading() {
      return this.sections.isLoading;
    },
    formattedLocale() {
      return this.$i18n.locale.split('_')?.[0] || 'en_US';
    },
  },
  created() {
    this.fetchSections();
  },
  methods: {
    fetchSections() {
      this.$store.dispatch('docs/fetchSections');
    },
  },
  watch: {
    '$i18n.locale': {
      handler: 'fetchSections',
    },
  },
};
